// extracted by mini-css-extract-plugin
export default {"root":"ListingTitle_root__PeAxV","badge":"ListingTitle_badge__neonA"};